<div class="global-notification font-semibold text-xl">
  <!---
    <span>Liga Rennen jeden zweiten Sonntag um <i class="text-orange-500">21:00 Uhr</i> - Neue Fahrer sind immer Willkommen!</span>
  -->
  <span>Liga Rennen jeden zweiten Sonntag um <i class="text-orange-500">21:00 Uhr</i> - Season 6 steht in den Startlöchern. Termine sind fest!</span>
</div>